<template>
    <b-modal
        v-model="shown"
        centered
        title="Import costs"
        lazy
    >

        <form
            action="/admin/import"
            enctype="multipart/form-data"
            method="post"
        >
            <input
                type="hidden"
                name="csrf_token"
                :value="csrf"
            >

            <input
                type="hidden"
                name="costable_type"
                :value="costableType"
            >

            <input
                type="hidden"
                name="costable_id"
                :value="costableId"
            >

            <input
                type="hidden"
                name="import_type"
                value="costs"
            >

            <div class="mb-5">
                <input
                    type="file"
                    name="file"
                >
            </div>

            <b-button
                type="submit"
                variant="primary"
            >
                Upload
            </b-button>
        </form>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                @click="handleClose"
            >
                Close
            </b-btn>
        </div>

    </b-modal>
</template>

<script>
export default {

    data() {
        return {
            shown: false,
        };
    },

    computed: {
        csrf: () => document.head.querySelector('meta[name="csrf-token"]'),
        costableType() {
            return this.$store.getters['costable/costableType'];
        },
        costableId() {
            return this.$store.getters['costable/costableId'];
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openImportModal, async () => {
            this.shown = true;
        });
    },

    methods: {
        handleClose() {
            this.shown = false;
        },
    },

};
</script>
